import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { fetchWorkRelationships } from "../../../../actions/dropdowns.actions";
import { updateUserData } from "../../../../actions/user.actions";
import * as commonActions from "./../../../../actions/common.actions";

import References from "../components/References";

class ReferencesContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchWorkRelationships();
  }

  componentWillUnmount() {
    this.props.commonActions.showError(null);
  }

  handleSubmit(data) {
    data.step_id = 4;

    this.props.updateUserData(data, "/member/confirmation");
  }

  render() {
    return (
      <References
        workRelations={this.props.workRelations}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    workRelations: state.dropdowns.workRelationship.data,
    formValid: state.form.formValid
  };
};

const mapDispatchToProps = dispatch => ({
  fetchWorkRelationships: () => dispatch(fetchWorkRelationships()),
  updateUserData: (user, redirect) => dispatch(updateUserData(user, redirect)),
  commonActions: bindActionCreators(commonActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferencesContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/references/containers/ReferencesContainer.js